import get from 'lodash/get';
import { serviceTypes } from 'utils/constants/serviceTypes';
import { ROLES } from 'utils/constants/roles';

export const getPatrols = (personnelDetails, patrols) => {
  if (personnelDetails?.details?.services) {
    const selectedPatrols = getPatrolsByServiceType(
      personnelDetails.details.services,
      patrols,
    );

    const roles = get(personnelDetails, 'general.roles');

    if (roles.includes(ROLES.RESPONDER.id)) {
      // Responder => free to do all patrols
      return getPatrolName(selectedPatrols);
    } else if (roles.includes(ROLES.GUARD.id)) {
      // if guard has mobile patrol/multi site, then give them the access
      let multisitePatrols = [];
      if (
        personnelDetails.details.services.includes(
          serviceTypes.patrol.multiSite,
        )
      ) {
        // guard needs all multi site and single site only they are assigned to
        multisitePatrols = selectedPatrols.filter(
          patrol => patrol.isMultiSite === true,
        );
      }
      // Guards => only can be assigned to patrol where patrol.site === guard assigned site
      const assignedSiteId = get(personnelDetails, 'details.assignedSite.id');
      const allowedPatrols = selectedPatrols.filter(
        patrol => patrol.site.id === assignedSiteId,
      );
      // transform the list
      return getPatrolName([...allowedPatrols, ...multisitePatrols]);
    } else {
      return [];
    }
  } else {
    return [];
  }
};

export const getPatrolsByServiceType = (personnelServices, patrols) => {
  if (
    checkPersonnelServices(
      [serviceTypes.patrol.multiSite, serviceTypes.patrol.singleSite],
      personnelServices,
    )
  ) {
    return patrols;
  } else if (
    checkPersonnelServices([serviceTypes.patrol.singleSite], personnelServices)
  ) {
    return patrols.filter(patrol => patrol.isMultiSite === false);
  } else if (
    checkPersonnelServices([serviceTypes.patrol.multiSite], personnelServices)
  ) {
    return patrols.filter(patrol => patrol.isMultiSite === true);
  } else {
    return [];
  }
};

const checkPersonnelServices = (servicesToHave, personnelServices) => {
  return servicesToHave.every(service => personnelServices.includes(service));
};

const getCombinedPatrolLabel = (businessClient, site, patrolName) => {
  let string = '';
  if (businessClient) {
    string += businessClient.businessClientName
      ? `${businessClient.businessClientName}`
      : '';
  }
  if (site) {
    //Only add the : if the string is not empty
    if (string.length > 0) {
      string += `: `;
    }
    string += site.siteName ? `${site.siteName}` : '';
  }
  if (patrolName) {
    //Only add the : if the string is not empty
    if (string.length > 0) {
      string += `: `;
    }
    string += `${patrolName}`; //this is required so never blank
  }
  return string;
};

const getPatrolName = patrols => {
  return patrols.reduce((allPatrols, patrol) => {
    if (patrol.isMultiSite) {
      allPatrols.push({ id: patrol.id, label: patrol.patrolName });
    } else {
      allPatrols.push({
        id: patrol.id,
        label: getCombinedPatrolLabel(
          patrol.businessClient,
          patrol.site,
          patrol.patrolName,
        ),
      });
    }
    return allPatrols;
  }, []);
};

// if personnel role is manager => can edit all roles except manager and supervisor
// sc_manager, edit all roles
//supervisor, manager can only be eited by sc_manager

export const checkEditable = state => {
  const userIsScManager = get(state, 'user.general.roles').includes(
    ROLES.SECURITY_COMPANY_MANAGER.id,
  );

  const userIsManager = get(state, 'user.general.roles').includes(
    ROLES.MANAGER.id,
  );

  const userIsSupervisor = get(
    state,
    'personnel.details.others.roles.value',
    [],
  ).includes(ROLES.SUPERVISOR.id);

  const isClickedPersonnelManager = get(
    state,
    'personnel.details.others.roles.value',
    [],
  ).includes(ROLES.MANAGER.id);

  if (userIsScManager) {
    return true;
  } else if (userIsManager) {
    if (isClickedPersonnelManager || userIsSupervisor) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const isRoleSupervisorOnly = values => {
  return values.role.includes(ROLES.SUPERVISOR.id) && !values.isResponder;
};

export const changeValuesBasedOnRole = values => {
  if (isRoleSupervisorOnly(values)) {
    return { transportService: [], patrolService: [], qualifications: [] };
  } else {
    return {
      transportService: values.transportService,
      patrolService: values.patrolService,
      qualifications: values.qualifications,
    };
  }
};
